import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { PathPickOrdersResponse } from "@/features/pathpick/features/order-history/types/response";
import { PathPickOrdersRequestParams } from "@/features/pathpick/features/order-history/types/request-params";

const url = {
  getPathPickOrders: (companyId: number) =>
    `/buyers/${companyId}/pathpick/orders`,
};

export const pathPickOrderHistoryQueryApi = {
  // 패스픽 주문 목록 조회 — 상태 그룹/검색어/주문일 범위/페이징을 전부 서버에서 처리한다.
  getPathPickOrders: async (
    companyId: number,
    params?: PathPickOrdersRequestParams
  ) => {
    const { data } = await axiosClient.get<PathPickOrdersResponse>(
      url.getPathPickOrders(companyId),
      { params: params ? toSnakeKeyObject(params) : undefined }
    );
    return data;
  },
};
